module.exports = __webpack_public_path__ + "img/ENDURANCE.d1a5b935.png";